import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { FilterOperation } from "src/app/models/custom-table/custom-table.model";
import { AppState } from "src/app/store/reducers";

import { setAdvancedFilterQuery } from "../../utils/tableUtils";
import { AppSessionService } from "../app-session/app-session.service";

const EMPTY_STRING = "";

@Injectable({
  providedIn: "root",
})
export class DashboardService {
  private BASE_URL = this.appSession.baseUrl + "/api/v1/dashboard";

  constructor(
    private http: HttpClient,
    private store: Store<AppState>,
    private appSession: AppSessionService
  ) {}

  public getVehicleAverages(vehicleCode: string): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });
    const url = `${this.appSession.baseUrl + "/api/v1/dashboard/averages/"}`;

    if (vehicleCode && vehicleCode.length > 0) {
      headers = headers.append("query", `vehicle.code==${vehicleCode}`);
    }
    return this.http.post(url, "", { headers });
  }

  getAverageComsuptionList(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }

    return this.http.post(
      `${this.appSession.baseUrl + "/api/v1/dashboard/averages"}`,
      "",
      { headers }
    );
  }

  getTransactionsList(
    paging?: any,
    filteringArgs?: any,
    sortingArgs?: any,
    advancedFilteringArgs?: any
  ): Observable<any> {
    let headers = new HttpHeaders({
      "Content-type": "application/json",
    });

    let filterQuery = EMPTY_STRING;
    let advancedFilterQuery = EMPTY_STRING;
    let orderQuery = EMPTY_STRING;

    if (advancedFilteringArgs) {
      advancedFilterQuery = setAdvancedFilterQuery(advancedFilteringArgs);
    }

    if (sortingArgs) {
      const { active, direction } = sortingArgs;
      orderQuery += active + "," + direction.toUpperCase();
    }

    if (filterQuery.length > 0 || advancedFilterQuery.length > 0) {
      headers = headers.append(
        "query",
        `${filterQuery} ${
          filterQuery.length > 0 && advancedFilterQuery.length > 0
            ? FilterOperation.AND
            : ""
        } ${advancedFilterQuery}`
      );
    }

    if (orderQuery.length > 0) {
      headers = headers.append("sort", orderQuery);
    }
    let body = {
      groupBy: "PRODUCT_GROUP", // ENUM DashboardMovementsOperationDTO com os valores seguintes  [NONE, SITE, PRODUCT, PRODUCT_GROUP, VEHICLE, EMPLOYEE, CUSTOMER ]
    };
    return this.http.post(
      `${this.appSession.baseUrl + "/api/v1/dashboard/transactions"}`,
      body,
      { headers }
    );
    // }
  }
}
